<div class="relative overflow-hidden min-h-[380px] sm:min-h-0">

    <!-- Imagen: cover en mobile (absolute), natural en desktop (static) -->
    <img [src]="bannerSrc" alt="banner"
         class="absolute inset-0 w-full h-full object-cover object-center
                sm:static sm:inset-auto sm:h-auto sm:w-full">

    <!-- Gradiente: solo mobile -->
    <div class="absolute inset-0 bg-gradient-to-t from-transparent via-Navy/60 to-Navy/95 sm:hidden"></div>

    <!-- Overlay de contenido -->
    <div class="absolute inset-0 flex items-center justify-center">

        <!-- Círculo exterior: transparente en mobile, círculo en sm+ -->
        <div class="flex items-center justify-center
                    sm:aspect-square sm:h-[97%] sm:rounded-full sm:bg-Navy/50">

            <!-- Círculo interior: columna en mobile, círculo en sm+ -->
            <div class="relative flex flex-col items-center justify-center text-center
                        gap-3 px-6 w-full
                        sm:aspect-square sm:w-[77%] sm:rounded-full sm:bg-Navy/85 sm:gap-2 sm:px-[10%] md:gap-3">

                <!-- Ícono desktop: absolute top-right, oculto en mobile -->
                <!-- Usa clases estáticas (no sm:absolute) para que Tailwind las genere siempre -->
                <div class="hidden sm:flex absolute top-[10%] right-[10%] w-[14%] aspect-square
                            rounded-full bg-white items-center justify-center shadow-md overflow-hidden">
                    <ng-container [ngTemplateOutlet]="iconTpl"></ng-container>
                </div>

                <!-- Título -->
                <h1 class="text-white font-bold font-serif leading-[1.25]
                           text-[20px] sm:text-[14px] md:text-[17px] lg:text-[21px] xl:text-[24px]"
                    data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                    {{ texts?.banner_section?.title }}
                </h1>

                <!-- Descripción -->
                <p class="text-white/75 leading-[1.6]
                          text-[13px] sm:text-[11px] sm:max-w-[85%] md:text-[14px] lg:text-[16px]"
                   data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
                    {{ texts?.banner_section?.description }}
                </p>

                <!-- Fila: botón + ícono mobile -->
                <div class="flex items-center gap-3 justify-center"
                     data-aos="fade-up" data-aos-duration="500" data-aos-delay="400">

                    <button (click)="onScrollToChat()"
                            class="text-white font-bold uppercase bg-Teal rounded-full border border-Teal
                                   transition-all hover:bg-CyanBlue hover:border-CyanBlue
                                   py-[9px] px-[22px] text-[12px]
                                   sm:py-[6px] sm:px-[18px] sm:text-[12px]
                                   md:py-[7px] md:px-[24px] md:text-[14px] lg:text-[15px]">
                        AGENDAR UNA CITA
                    </button>

                    <!-- Ícono mobile: inline junto al botón, oculto en sm+ -->
                    <div class="sm:hidden w-14 h-14 rounded-full bg-white flex items-center justify-center shadow-md overflow-hidden shrink-0">
                        <ng-container [ngTemplateOutlet]="iconTpl"></ng-container>
                    </div>

                </div>

            </div>
        </div>
    </div>

</div>

<!-- <img> del ícono declarado una sola vez -->
<ng-template #iconTpl>
    <img [src]="imgBanner?.icon_logo" alt="Clarity" class="w-full h-full object-contain p-[8%]">
</ng-template>
